/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdpsychologie13Inputs */

const en__field_enum_sdpsychologie13 = /** @type {(inputs: _Field_Enum_Sdpsychologie13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05 - Psychologie und Sportwissenschaften`)
};

const de__field_enum_sdpsychologie13 = /** @type {(inputs: _Field_Enum_Sdpsychologie13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05 - Psychologie und Sportwissenschaften`)
};

/**
* | output |
* | --- |
* | "05 - Psychologie und Sportwissenschaften" |
*
* @param {_Field_Enum_Sdpsychologie13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdpsychologie13 = /** @type {((inputs?: _Field_Enum_Sdpsychologie13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdpsychologie13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdpsychologie13(inputs)
	return de__field_enum_sdpsychologie13(inputs)
});
export { _field_enum_sdpsychologie13 as "_field_enum_SDPSYCHOLOGIE" }